import { render, staticRenderFns } from "./StudentAttendanceReportTable.vue?vue&type=template&id=70d54546"
import script from "./StudentAttendanceReportTable.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports